import React, { useEffect } from 'react';
import SEO from '../components/SEO';
import SitePage, { CallToAction, styles, T, ACCENT } from '../components/site/SitePage';

const POINTS = [
  ['Je connais votre métier', 'Couverture de stock, MOQ, marge par canal : on gagne des semaines de cadrage.'],
  ['Un seul interlocuteur', 'Je comprends le besoin, je conçois la base, je développe les outils et je les livre. Deux projets à la fois au maximum, réponse sous 24 h ouvrées.'],
  ['Bases de données et IA', 'Python, SQL, React, et vos données branchées sur Claude ou ChatGPT quand ça sert.']
];

const AboutPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <SitePage>
      <SEO
        title="Mattéo, développeur d'outils sur mesure e-commerce"
        description="Mattéo, ingénieur data et développeur d'outils sur mesure pour l'e-commerce : je remplace les Excel des équipes par une base unique et des outils."
        path="/about"
        breadcrumb={[['À propos', '/about']]}
      />
      <section style={{ ...styles.container, padding: '72px 24px 24px', display: 'flex', flexWrap: 'wrap', gap: 56, alignItems: 'center' }}>
        <div style={{ flex: '1 1 520px', minWidth: 0, display: 'flex', flexDirection: 'column', gap: 20 }}>
          <p style={styles.kicker}>À propos</p>
          <h1 style={styles.h1}>Mattéo, développeur d'outils sur mesure</h1>
          <p style={styles.lead}>Ingénieur data, je travaille dans l'e‑commerce. Mon quotidien : remplacer les Excel des équipes ventes, achats, logistique et direction par une base unique, et construire dessus les outils qu'elles ouvrent chaque matin.</p>
          <p style={styles.lead}>Avec Autoria, je le fais pour des marques e‑commerce : un premier outil, puis votre système, à un prix fixé d'avance.</p>
        </div>
      </section>

      <section style={{ ...styles.container, paddingTop: 40 }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(min(260px, 100%), 1fr))', gap: 1, background: T.line, border: `1px solid ${T.line}` }}>
          {POINTS.map(([title, text]) => (
            <div key={title} style={{ padding: 22, background: '#FFFFFF', display: 'flex', flexDirection: 'column', gap: 6 }}>
              <p style={{ margin: 0, fontWeight: 700 }}>{title}</p>
              <p style={{ margin: 0, fontSize: 15, color: T.muted }}>{text}</p>
            </div>
          ))}
        </div>
        <p style={{ margin: '24px 0 0', fontFamily: T.mono, fontSize: 13, color: T.faint }}>
          Avis clients sur <a href="https://www.malt.fr/profile/matteogalfre" style={{ color: ACCENT }}>Malt</a> · <a href="https://www.linkedin.com/in/mgalfre/" style={{ color: ACCENT }}>LinkedIn</a>
        </p>
      </section>

      <CallToAction from="a-propos" title="Un fichier vous coûte trop de temps ?" text="Montrez-le-moi : 30 minutes, et un avis franc sur ce qui vaut la peine d'être construit." />
    </SitePage>
  );
};

export default AboutPage;
